import { useCallback, useState } from 'react';

type TOptions = {
  setPage: (page: number) => void;
};

export const useExternallyManagedFilter = ({ setPage }: TOptions) => {
  const [includeExternallyManaged, setIncludeExternallyManaged] = useState(false);

  const toggleIncludeExternallyManaged = useCallback(() => {
    setPage(1);
    setIncludeExternallyManaged((current) => !current);
  }, [setPage]);

  return { includeExternallyManaged, toggleIncludeExternallyManaged };
};
